import MicRecorder from "./mic-recorder/mic-recorder";

class RecordingService {
  constructor() {
    this.startTime = null;
    this.context = null;
    this.recorder = new MicRecorder({ bitRate: 64 });
  }

  async start() {
    this.initAudioContextIfNeeded();
    await this.recorder.start(this.context);
    this.startTime = new Date();
  }

  async stop() {
    const [, audioBlob] = await this.recorder.stopAndEncodeToMp3(); // returns [buffer, blob]
    const audioUrl = URL.createObjectURL(audioBlob);
    const duration = this.getCurrentDuration();
    return { audioBlob, audioUrl, duration };
  }

  initAudioContextIfNeeded() {
    if (this.context) return;
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new AudioContext();
  }

  getCurrentDuration() {
    const endTime = new Date();
    const duration = Math.floor((endTime - this.startTime) / 1000);
    return duration;
  }
}

export default RecordingService;
